module.exports = __webpack_public_path__ + "img/atendimento.053957d1.svg";